<template><div><h1>VUX V2.6.1 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] support prop:compute-days-function for dynamically setting days #1992</li>
</ul>
<h2><a href="/en/components/grid.html">Grid</a></h2>
<ul><li>[feature] add `cols` props</li>
</ul>
<h2><a href="/en/components/scroller.html">Scroller</a></h2>
<ul><li>[change] call `reset` in `updated` hook</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[enhance] set label for attribute #1983</li>
<li>[feature] support prop:mask</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.1-124.vue?33c667aa